import log from 'loglevel';

/*
 * API query helpers
 */

/*
 * Caller to backend API; returns a promise
 */
export default (value, ipaflavour) => {
  let fullquery = `/g2p?w=${value.toLowerCase()}`;
  if (ipaflavour) { fullquery += `&ipa=${ipaflavour}` }

  return fetch(fullquery, {
      accept: 'application/json',
  })
}

/*
 * Checks the return code of fetch call (in range 200-299)
 */
export const checkStatus = (response) => {
  if (response.ok) {
    return response;
  }
  const error = new Error(`HTTP Error ${response.statusText}`);
  error.status = response.statusText;
  error.response = response;
  log.error('checkStatus()', error); // eslint-disable-line no-console
  throw error;
}

/*
 * Unwraps return promise from fetch into JSON object
 */
export const parseJSON = (response) => {
  var contentType = response.headers.get("content-type");
  if(contentType && contentType.indexOf("application/json") !== -1) {
    return response.json()
      .then(function(json) {
        log.trace(`got JSON: ${json}`);
        return json;
      })
      .catch (e => {
        log.warn('expected JSON')
        const error = new Error('Server did not return correct data')
        throw error
      })
  } else {
    log.warn("parseJSON(): We haven't got JSON!");
    const error = new Error('Server did not return correct data')
    throw error
  }
}




// WEBPACK FOOTER //
// ./src/Client.js